module.exports = __webpack_public_path__ + "static/media/afl_everyday_digital.8669fd40.png";